import "@/App.css";
import { BrowserRouter, Routes, Route, Link, NavLink } from "react-router-dom";
import { Globe2 } from "lucide-react";
import QuizPage from "@/pages/QuizPage";
import StatsPage from "@/pages/StatsPage";
import SettingsPage from "@/pages/SettingsPage";
import { Toaster } from "@/components/ui/sonner";

const Header = () => {
  const navCls = ({ isActive }) =>
    `text-xs uppercase tracking-[0.18em] font-medium transition-colors ${
      isActive ? "text-[#0A0A0A]" : "text-[#A1A1AA] hover:text-[#0A0A0A]"
    }`;
  return (
    <header className="border-b border-[#E4E4E7] bg-white">
      <div className="w-full max-w-md mx-auto flex items-center justify-between px-4 py-4 sm:px-6">
        <Link to="/" className="flex items-center gap-2" data-testid="header-logo-link">
          <Globe2 className="h-5 w-5 text-[#0A0A0A]" strokeWidth={2.25} />
          <span className="font-black tracking-tighter text-[#0A0A0A] text-base">
            CAPITALS
          </span>
        </Link>
        <nav className="flex items-center gap-5">
          <NavLink to="/" end className={navCls} data-testid="nav-quiz-link">
            Quiz
          </NavLink>
          <NavLink to="/stats" className={navCls} data-testid="nav-stats-link">
            Stats
          </NavLink>
          <NavLink to="/settings" className={navCls} data-testid="nav-settings-link">
            Settings
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-[#F9F9FA] text-[#0A0A0A]">
      <BrowserRouter>
        <Header />
        <main className="w-full max-w-md mx-auto px-4 sm:px-6 py-6">
          <Routes>
            <Route path="/" element={<QuizPage />} />
            <Route path="/stats" element={<StatsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Routes>
        </main>
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
